import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";

export default class ProfileService {
  constructor($http, $localStorage, $state, $q, $timeout, SecurityService, AuthService, EnvService) {
    this.COMPLETE_PROFILE = 1;
    this.VERIFY_PHONE = 2;
    this.INPUT_PHONE_NUMBER = 3;
    this.LOCATION = 4;
    this.WORK_ELIGIBILITY = 5;
    this.BG_CONSENT = 6;
    this.PROFILE_PICTURE = 7;
    this.PAYMENTS = 8;

    //this.BG_CONSENT = 8;
    //this.PROFILE_PICTURE = 6;
    //this.PAYMENTS = 7;

    this.APPLY_ELIGIBLE = 11;
    this.FULL_ELIGIBLE = 12;

    this.STATUS_MAP = {
      [this.COMPLETE_PROFILE]: "complete your profile",
      [this.VERIFY_PHONE]: "verify your phone number",
      [this.INPUT_PHONE_NUMBER]: "input phone number",
      [this.LOCATION]: "location",
      [this.WORK_ELIGIBILITY]: "work eligibility",
      [this.BG_CONSENT]: "background consent",
      [this.PROFILE_PICTURE]: "profile picture",
      [this.PAYMENTS]: "payments",
    };

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$env = EnvService;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.default_jobbler_image = "/app/vendor/images/defaultimg.jpeg";
    this.default_cover_photo = "/app/vendor/images/default-cover-photo.jpg";
    this.validateUrlAll = "jbl/v1/validate?format=json&verbosity=5";
    this.resendEmailUrl = "register/resend-verification-email?format=json&conf=web";
    this.checkStatusUrl = "jbl/v1/validate?format=json&fields=id,username,isVerified";
    this.validateUrl =
      "jbl/v1/validate?format=json&fields=username,dateBirth,bio,video1,nickname,ssn,id,smsChatNotificationOn,filePROFILE_IMAGE1IMG_160x160,profilePictureUri,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partner,company.rds_company,notifPref.jobbleTypes,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
    this.createRecipientUrl = "jbl/v1/stripe/create-recipient-stripe-account?format=json&conf=web&typeAccount=individual";
    this.imageUrl = "jbl/v1/validate?format=json&fields=username,picture1,picture2,filePROFILE_IMAGE1IMG_160x160,resumeLink,resumeLink2";
    if (this.$localStorage.logged_user) {
      this.resumeUrl = "jbl/v1/users/" + this.$localStorage.logged_user.id + "/files?format=json&conf=web&fileType=PROFILE_RESUME1&replace=true";
    }
  }

  getMultiMediaData() {
    var _this = this;
    let url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&verbosity=5";
    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  checkValidationStatus() {
    var _this = this;
    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + _this.checkStatusUrl,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return _this.$http(req);
  }

  getProfilePicture(token) {
    var _this = this;
    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + _this.imageUrl,
      headers: {Authorization: "Bearer " + token},
      data: {},
    };
    return _this.$http(req);
  }

  validateUserByToken(token) {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + _this.validateUrl,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  sendSMSCode() {
    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/verifications",
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return this.$http(req);
  }

  validateSMSCode(code) {
    var req = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/verifications/" + code,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return this.$http(req);
  }

  getMultiMediaDataWithFormats() {
    var _this = this;

    let url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/validate?format=json&fields=id,access_token,picture1,picture1s,picture2,filePROFILE_IMAGE1IMG_160x160,filePROFILE_IMAGE2IMG_160x160,filePROFILE_IMAGE3IMG_160x160,filePROFILE_IMAGE4IMG_160x160,filePROFILE_IMAGE5IMG_160x160,filePROFILE_IMAGE6IMG_160x160";
    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return _this.$http(req);
  }

  getJobblerPictures(user, is_edit, current_model) {
    var _this = this;
    let picture_data = {};
    picture_data.picture_array_160x160 = [];
    console.log("what is the edit data in the get jobbler pictures");
    console.dir(is_edit);
    if (is_edit) {
      console.log("in the edit part of the thing");
      console.dir(current_model);
      let picture_array = current_model.picture_data.picture_array_160x160;
      try {
        for (var i = 0; i < picture_array.length; i++) {
          if (picture_array[i].id === is_edit.id) {
            console.log("we have a match");
            picture_array[i].url = is_edit.pic_url;
            break;
          }
        }
      } catch (err) {
        console.log("error in the editing of photo");
        console.dir(err);
      } finally {
        console.log("in the finally for replace");
        console.dir(picture_array);
        current_model.picture_data.picture_array_160x160 = [];
        current_model.picture_data.picture_array_160x160 = picture_array;
        console.log("what are we returning?");
        console.dir(current_model);
        return current_model;
      }
    } else {
      try {
        if (user.filePROFILE_IMAGE1IMG_160x160) {
          let picture_160x160_1 = {
            id: 1,
            url: user.filePROFILE_IMAGE1IMG_160x160,
          };
          //picture_data.picture_array_160x160.push(picture_160x160_1);
          picture_data.main_picture = user.picture1;
        } else {
          //picture_data.main_picture=_this.default_jobbler_image;
        }
        if (user.filePROFILE_IMAGE2IMG_160x160) {
          let picture_160x160_2 = {
            id: 2,
            url: user.filePROFILE_IMAGE2IMG_160x160,
          };
          if (user.picture2) {
            picture_data.cover_picture = user.picture2;
          } else {
            picture_data.cover_picture = user.filePROFILE_IMAGE2IMG_160x160;
          }
          if (!picture_data.main_picture) {
            //picture_data.main_picture=user.filePROFILE_IMAGE2IMG_160x160;
          }
        } else {
          //picture_data.main_picture=_this.default_jobbler_image;
        }
        if (user.filePROFILE_IMAGE3IMG_160x160) {
          let picture_160x160_3 = {
            id: 3,
            url: user.filePROFILE_IMAGE3IMG_160x160,
          };
          picture_data.picture_array_160x160.push(picture_160x160_3);
        } else {
          //picture_data.main_picture=_this.default_jobbler_image;
        }
        if (user.filePROFILE_IMAGE4IMG_160x160) {
          let picture_160x160_4 = {
            id: 4,
            url: user.filePROFILE_IMAGE4IMG_160x160,
          };
          picture_data.picture_array_160x160.push(picture_160x160_4);

          /*if (!picture_data.main_picture){
					  picture_data.main_picture=user.filePROFILE_IMAGE4IMG_160x160;
				  }*/
        } else {
          //picture_data.main_picture=_this.default_jobbler_image;
        }
        if (user.filePROFILE_IMAGE5IMG_160x160) {
          let picture_160x160_5 = {
            id: 5,
            url: user.filePROFILE_IMAGE5IMG_160x160,
          };
          picture_data.picture_array_160x160.push(picture_160x160_5);
        } else {
          //picture_data.main_picture=_this.default_jobbler_image;
        }
        if (user.filePROFILE_IMAGE6IMG_160x160) {
          let picture_160x160_6 = {
            id: 6,
            url: user.filePROFILE_IMAGE6IMG_160x160,
          };
          picture_data.picture_array_160x160.push(picture_160x160_6);
          if (!picture_data.main_picture) {
            //picture_data.main_picture=user.filePROFILE_IMAGE6IMG_160x160;
          }
        } else {
          //picture_data.main_picture=_this.default_jobbler_image;
        }
      } catch (err) {
        alert("error parsing pictures");
      } finally {
        console.log("in the finally with picture data");
        console.dir(picture_data);
        if (!picture_data.main_picture) {
          picture_data.main_picture = _this.default_jobbler_image;
        }
        if (!picture_data.cover_picture) {
          picture_data.cover_picture = _this.default_cover_photo;
        }
        return picture_data;
      }
    }
  }

  uploadProfilePicture(picture) {
    return this.uploadPicture(picture, "PROFILE_IMAGE1");
  }

  uploadProfileVideo(picture) {
    return this.uploadPicture(picture, "PROFILE_VIDEO1");
  }

  uploadCoverPicture(picture) {
    return this.uploadPicture(picture, "PROFILE_IMAGE2");
  }

  uploadPictures(picture, number) {
    console.log("Is this getting called multiple times???");
    console.dir(number);
    return this.uploadPicture(picture, "PROFILE_IMAGE" + number);
  }

  uploadPicture(picture, fileType) {
    const req = {
      method: "POST",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$localStorage.logged_user.id +
        "/files?format=json&conf=web&fileType=" +
        fileType +
        "&replace=true",
      headers: {
        Authorization: "Bearer " + this.$auth.getAccessToken(),
        "Content-type": undefined,
      },
      transformRequest: angular.identity,
      data: picture,
    };
    return this.$http(req);
  }

  deletePicture(fileType) {
    console.log("deletePicture");
    console.dir(fileType);
    const req = {
      method: "DELETE",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/file-types/" + fileType + "?format=json&conf=web",
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return this.$http(req);
  }

  saveUser(user) {
    if (user.preferredName) {
      user.nickname = user.preferredName;
    }

    const logged_user = this.$localStorage.logged_user || {};

    let req = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + logged_user.access_token,
      },
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + logged_user.id + "?format=json&fields=id",
      data: user,
    };

    return this.$http(req);
  }

  saveUserBasic(user) {

    const logged_user = this.$localStorage.logged_user || {};

    let req = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + logged_user.access_token,
      },
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + logged_user.id + "/updateMinimalFields",
      data: user
    };

    return this.$http(req);
  }

  getLatestTutorial() {
    var _this = this;

    let url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=id,billingTutorialTracking";
    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  getPaymentInfo() {
    var _this = this;

    let url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/validate?format=json&fields=id,access_token,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.setupIntentId,company.undeletedPaymentInfos.lastUpdated,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname";
    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return _this.$http(req);
  }

  /*
    getPaymentInfo() {
        var _this = this;

        let url =
            _this.$env.getAPIEndPoint() +
            "jbl/v1/validate?format=json&fields=id,access_token,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.lastUpdated,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname";
        let req = {
            method: "GET",
            url: url,
            headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
            data: {},
        };
        return _this.$http(req);
    }*/

  updatePrefJobbleTypes(jobble_types_array) {
    var _this = this;
    let jt_ids = {notifPref: {jobbleTypes: jobble_types_array}};
    let req = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=id,notifPref.jobbleTypes",
      data: jt_ids,
    };
    return _this.$http(req);
  }

  uploadResume(file) {
    var _this = this;
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + _this.resumeUrl,
      headers: {
        Authorization: "Bearer " + _this.$auth.getAccessToken(),
        "Content-type": undefined,
      },
      transformRequest: angular.identity,
      data: file,
    };
    return _this.$http(req);
  }

  getSocialLinks() {
    var _this = this;
    let url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=id,access_token,instagram,facebook,linkdedIn,googlePlus,twitter";
    let req = {
      method: "GET",
      url: url,
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {},
    };
    return _this.$http(req);
  }

  updateSocialLinks(data) {
    var _this = this;
    let req = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        _this.$localStorage.logged_user.id +
        "?format=json&fields=id,access_token,instagram,facebook,linkdedIn,googlePlus,twitter",
      data: {
        facebook: data.facebook,
        linkdedIn: data.linkedin,
        twitter: data.twitter,
        instagram: data.instagram,
        googlePlus: data.google,
      },
    };
    return _this.$http(req);
  }

  isEmail(val) {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      val
    );
  }

  isPhone(val) {
    return /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val);
  }

  userConsent(copy) {
    var _this = this;

    const req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/consents?consentAccepted=true&receiveCopy=" + copy,
      headers: {
        Authorization: "Bearer " + this.$auth.getAccessToken(),
        "Content-type": "application/json",
      },
      data: {},
    };

    return this.$http(req);
  }

  resendEmail(user) {
    var _this = this;

    const req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + _this.resendEmailUrl,
      headers: {
        Authorization: "Bearer " + this.$auth.getAccessToken(),
        "Content-type": "application/json",
      },
      data: {email: user.email},
    };

    return this.$http(req);
  }

  getUserProfileEligibility(user) {
    if (this.getUserProfileScreen(user) >= this.PROFILE_PICTURE) return this.APPLY_ELIGIBLE;

    return 0;
  }

  getMostRecentUser() {
    return new Promise((resolve, reject) => {
      resolve(this.$auth.getUserData());
    });
  }

  getUserProfileScreen(user, profileStatus) {
    /*(/^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/)
        (/^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/)*/
    const simpleSsn = /^\d{9}$/;
    const ssnPattern = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
    const phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    const zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

    this.currentUser = user || this.currentUser;

    if (!user) return 0;

    if (!user.firstName || !user.lastName || !user.homeContactInfo) return this.COMPLETE_PROFILE;

    if (!user.homeContactInfo.phoneMobile || !phonePattern.test(user.homeContactInfo.phoneMobile)) return this.VERIFY_PHONE;

    if (!user.homeContactInfo.isMobilePhoneVerified || user.homeContactInfo.isMobilePhoneVerified === false) return this.INPUT_PHONE_NUMBER;

    if (
      !user.homeContactInfo ||
      !user.homeContactInfo.streetLine1 ||
      !user.homeContactInfo.zipCode ||
      !zipPattern.test(user.homeContactInfo.zipCode) ||
      !user.homeContactInfo.city ||
      !user.homeContactInfo.state ||
      user.homeContactInfo.state === "--"
    )
      return this.LOCATION;

    console.log("what is the user here");
    console.dir(user);
    console.dir(simpleSsn.test(user.ssn));
    console.dir(profileStatus);

    if (user) {
      if (user.ssn) {
        if (user.ssn.includes("xxxxx")) {
          if (!user.acceptedBackgroundCheck || user.acceptedBackgroundCheck === false) {
            return this.BG_CONSENT;
          } else {
            this.PROFILE_PICTURE;
          }
        } else {
          if (!user.ssn || !simpleSsn.test(user.ssn) || !user.dateBirth || !this.validateDateBirth(user.dateBirth)) return this.WORK_ELIGIBILITY;
        }
      } else {
        return this.WORK_ELIGIBILITY;
      }
    }

    if (!user.acceptedBackgroundCheck || user.acceptedBackgroundCheck === false) return this.BG_CONSENT;

    return this.PROFILE_PICTURE;
  }

  getUserProfileStatus(user) {
    const ssnPattern = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
    const phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    const zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

    if (!user) return 0;

    if (
      !user.firstName ||
      !user.lastName ||
      !user.homeContactInfo ||
      !user.homeContactInfo.phoneMobile ||
      !phonePattern.test(user.homeContactInfo.phoneMobile) ||
      !user.ssn ||
      !ssnPattern.test(user.ssn) ||
      !user.dateBirth ||
      !this.validateDateBirth(user.dateBirth)
    )
      return 1;

    if (
      !user.homeContactInfo ||
      !user.homeContactInfo.streetLine1 ||
      !user.homeContactInfo.zipCode ||
      !zipPattern.test(user.homeContactInfo.zipCode) ||
      !user.homeContactInfo.city ||
      !user.homeContactInfo.state ||
      user.homeContactInfo.state === "--"
    )
      return 2;

    if (!user.bio) return 3;

    if (!user.profilePictureUri) return 4;

    if (!user.notifPref || !user.notifPref.jobbleTypes || user.notifPref.jobbleTypes.length === 0) return 5;

    return 6;
  }

  validateProfile(user, field, errors) {
    errors = errors || {};

    if (field === "firstName") {
      errors["firstName"] = !user.firstName;
    }
    if (field === "lastName") {
      errors["lastName"] = !user.lastName;
    }
    if (field === "phoneMobile") {
      if (user.homeContactInfo.phoneMobile.length === 1 && user.homeContactInfo.phoneMobile === "1") {
          user.homeContactInfo.phoneMobile = "";
      }
      const phonePattern = /^(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/;
      //const phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
      //const phonePattern = /^[2-9]{2}[0-9]{8}$/;
      errors["phoneMobile"] = !(user.homeContactInfo.phoneMobile && phonePattern.test(user.homeContactInfo.phoneMobile));
    }
    if (field === "ssn") {
      const simpleSsn = /^\d{9}$/;
      //const ssnPattern = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
      errors["ssn"] = !(user.ssn && simpleSsn.test(user.ssn));
    }
    if (field === "dateBirth") {
      errors["dateBirth"] = !this.validateDateBirth(user.dateBirth);
    }
    if (field === "streetLine1") {
      errors["streetLine1"] = !user.homeContactInfo.streetLine1;
    }
    if (field === "zipCode") {
      const zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
      errors["zipCode"] = !(user.homeContactInfo.zipCode && zipPattern.test(user.homeContactInfo.zipCode));
    }
    if (field === "city") {
      errors["city"] = !user.homeContactInfo.city;
    }
    if (field === "state") {
      errors["state"] = !(user.homeContactInfo.state && user.homeContactInfo.state !== "--");
    }
    if (field === "bio") {
      errors["bio"] = !user.bio;
    }

    return errors;
  }

  dimensionsCalc(height, width) {

    let result;
    let div;

    if (width > height) {
      result = "default";
      div = height / width;
      console.log("div");
      console.dir(div);
    } else if (height > width) {
      result = "default-long";
      div = height / width;
      console.log("div");
      console.dir(div);
      if (div > 1.5) {
        result = "remove-class";
      }
    } else if (width === height) {
      result = "default";
    }

    return result;
  }

  validateDateBirth(dateBirth) {
    if (!dateBirth) return false;

    let birthDate = dateBirth;

    if (!(birthDate instanceof Date)) {
      birthDate = new Date(birthDate.replace("Z", ""));
    }

    const age = this.getAge(birthDate);

    return age >= 18 && age < 122;
  }

  getAge(birthDate) {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  extractFields(user, fields) {
    const homeContactInfoFields = ["streetLine1", "zipCode", "city", "state", "phoneMobile"];

    if (!fields || !user || fields.length === 0) return {};

    let model = {};

    fields.forEach((field) => {
      if (homeContactInfoFields.indexOf(field) !== -1) {
        model.homeContactInfo = model.homeContactInfo || {};
        model.homeContactInfo[field] = user && user.homeContactInfo ? user.homeContactInfo[field] : null;
      } else {
        model[field] = user[field];
      }
    });

    return model;
  }

  updatePassword(payload, userId) {
    console.log("updatePassword");
    console.dir(payload);
    console.dir(userId);
    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + userId + "/changePassword",
      headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
      data: payload
    };
    return this.$http(req);
  }
}

ProfileService.$inject = ["$http", "$localStorage", "$state", "$q", "$timeout", "security", "auth", "env"];



// WEBPACK FOOTER //
// ./client/app/services/profile.js